var map = {
	"./alligator.png": "4459",
	"./animal_dog_osuwari.png": "0bd8",
	"./bear.png": "d76a",
	"./cat.png": "1f53",
	"./duck.png": "d089",
	"./elephant.png": "6cd4",
	"./flamingo.png": "c849",
	"./giraffe.png": "5d0c",
	"./gorilla.png": "57c9",
	"./horse.png": "1b18",
	"./iguana.png": "4be4",
	"./jaguar.png": "712b",
	"./kamonohashi.png": "e86f",
	"./koala.png": "3578",
	"./lama.png": "02e4",
	"./lion.png": "7c1d",
	"./monkey.png": "e3d2",
	"./numbat.png": "6275",
	"./owl.png": "bc5c",
	"./penguin.png": "b897",
	"./quail.png": "449a",
	"./rhinoceros.png": "2540",
	"./sheep.png": "d16b",
	"./tiger.png": "deec",
	"./unicorn.png": "6800",
	"./vampire_bat.png": "120f",
	"./whale.png": "e15d",
	"./xerus.png": "32be",
	"./yak.png": "168a",
	"./zebra.png": "166d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";